<template>
  <div
    v-if="visible"
    class="register-popup-overlay"
    @click.self="closePopup"
  >
    <div class="register-popup">
      <button class="popup-close" @click="closePopup">&times;</button>

      <!-- 헤더 -->
      <div class="popup-header">
        <span class="approval-badge">청주시 사업계획 승인완료 · 2026.04.22</span>
        <h3>방문상담 예약</h3>
        <p>모델하우스는 <strong>방문예약제</strong>로 운영됩니다.<br>
          꼭 예약 후 방문해 주세요.</p>
      </div>

      <!-- 조감도 -->
      <div class="popup-render">
        <img :src="renderImage" alt="레이원시티 조감도" />
        <!-- 사은품 강조 배너 -->
        <div class="gift-banner">
          <span class="gift-icon">🎁</span>
          <div class="gift-text">
            <span class="gift-sub">예약 방문하시면</span>
            <strong class="gift-main">사은품 100% 증정</strong>
          </div>
        </div>
      </div>

      <!-- 폼 -->
      <div class="popup-body">
        <div class="popup-field">
          <label>성함</label>
          <input
            type="text"
            v-model="form.name"
            placeholder="성함을 입력해주세요"
            :disabled="isSubmitting"
          />
        </div>

        <div class="popup-field">
          <label>연락처</label>
          <div class="phone-inputs">
            <input
              ref="phone1"
              type="tel"
              inputmode="numeric"
              v-model="form.phone1"
              maxlength="3"
              placeholder="010"
              :disabled="isSubmitting"
              @input="onPhone1Input"
            />
            <span class="phone-dash">-</span>
            <input
              ref="phone2"
              type="tel"
              inputmode="numeric"
              v-model="form.phone2"
              maxlength="4"
              placeholder="0000"
              :disabled="isSubmitting"
              @input="onPhone2Input"
            />
            <span class="phone-dash">-</span>
            <input
              ref="phone3"
              type="tel"
              inputmode="numeric"
              v-model="form.phone3"
              maxlength="4"
              placeholder="0000"
              :disabled="isSubmitting"
            />
          </div>
        </div>

        <div class="popup-agree">
          <label>
            <input type="checkbox" v-model="form.agree" :disabled="isSubmitting" />
            개인정보 수집 및 이용에 동의합니다.
          </label>
        </div>

        <button class="popup-submit" :disabled="isSubmitting" @click="submit">
          {{ isSubmitting ? '예약 신청중...' : '방문상담 예약하기' }}
        </button>
        <a href="tel:1600-9768" class="popup-phone">
          <span class="phone-label">대표번호</span>
          1600-9768
        </a>
      </div>

      <button class="popup-today" @click="closeForToday">오늘 하루 보지 않기</button>
    </div>
  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'
import banner from '@/assets/banner/banner1.jpg'

const STORAGE_KEY = 'hideRegisterPopup'

export default {
  name: 'MobileRegisterPopup',
  data() {
    return {
      visible: false,
      isSubmitting: false,
      renderImage: banner,
      form: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        agree: false
      }
    }
  },
  mounted() {
    this.checkVisibility()
    window.addEventListener('open-register-popup', this.openPopup)
  },
  beforeUnmount() {
    window.removeEventListener('open-register-popup', this.openPopup)
    document.body.style.overflow = ''
  },
  methods: {
    checkVisibility() {
      const hideUntil = localStorage.getItem(STORAGE_KEY)
      if (hideUntil && Date.now() < Number(hideUntil)) return
      this.visible = true
      document.body.style.overflow = 'hidden'
    },
    openPopup() {
      this.visible = true
      document.body.style.overflow = 'hidden'
    },
    closePopup() {
      this.visible = false
      document.body.style.overflow = ''
    },
    closeForToday() {
      const tomorrow = new Date()
      tomorrow.setHours(23, 59, 59, 999)
      localStorage.setItem(STORAGE_KEY, tomorrow.getTime().toString())
      this.closePopup()
    },
    onPhone1Input() {
      this.form.phone1 = this.form.phone1.replace(/[^0-9]/g, '')
      if (this.form.phone1.length >= 3) {
        this.$refs.phone2.focus()
      }
    },
    onPhone2Input() {
      this.form.phone2 = this.form.phone2.replace(/[^0-9]/g, '')
      if (this.form.phone2.length >= 4) {
        this.$refs.phone3.focus()
      }
    },
    async submit() {
      const phone = `${this.form.phone1}-${this.form.phone2}-${this.form.phone3}`
      const phoneDigits = this.form.phone1 + this.form.phone2 + this.form.phone3
      if (!this.form.name.trim() || phoneDigits.length < 10) {
        alert('성함과 연락처를 정확히 입력해주세요.')
        return
      }
      if (!this.form.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }

      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.form.name,
          phone: phone
        }, 'popup')
        alert('방문 예약이 정상적으로 접수되었습니다.\n담당자가 빠르게 연락드리겠습니다.')
        this.form = {
          name: '',
          phone1: '010',
          phone2: '',
          phone3: '',
          agree: false
        }
        this.closePopup()
      } catch (e) {
        console.error(e)
        alert('등록 중 오류가 발생했습니다. 전화(1600-9768)로 문의해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.register-popup-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.register-popup {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  max-height: 92vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  -webkit-overflow-scrolling: touch;
}

.popup-close {
  position: absolute;
  top: 12px;
  right: 16px;
  background: rgba(0, 0, 0, 0.25);
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
  z-index: 10;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 헤더 */
.popup-header {
  background: linear-gradient(135deg, var(--main-color1) 0%, var(--main-color2) 100%);
  padding: 26px 28px 22px;
  text-align: center;
  position: relative;
}

.approval-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #d4af37;
  padding: 4px 12px;
  border: 1px solid rgba(212, 175, 55, 0.6);
  background: rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  margin-bottom: 12px;
}

.popup-header h3 {
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 10px;
  letter-spacing: -0.5px;
}

.popup-header p {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.6;
}

.popup-header p strong {
  color: #ffd680;
  font-weight: 800;
}

/* 조감도 */
.popup-render {
  position: relative;
  width: 100%;
  background: #000;
  line-height: 0;
}

.popup-render img {
  width: 100%;
  height: auto;
  display: block;
  opacity: 0.96;
}

/* 사은품 배너 */
.gift-banner {
  position: absolute;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 16px 9px 14px;
  background: linear-gradient(135deg, #d4af37 0%, #b8941f 100%);
  border-radius: 30px;
  box-shadow:
    0 6px 18px rgba(0, 0, 0, 0.35),
    0 0 0 2px rgba(255, 255, 255, 0.25) inset;
  white-space: nowrap;
  animation: gift-pulse 1.6s ease-in-out infinite;
}

@keyframes gift-pulse {
  0%, 100% {
    box-shadow:
      0 6px 18px rgba(0, 0, 0, 0.35),
      0 0 0 2px rgba(255, 255, 255, 0.25) inset,
      0 0 0 0 rgba(212, 175, 55, 0.6);
  }
  50% {
    box-shadow:
      0 6px 22px rgba(0, 0, 0, 0.4),
      0 0 0 2px rgba(255, 255, 255, 0.35) inset,
      0 0 0 8px rgba(212, 175, 55, 0);
  }
}

.gift-icon {
  font-size: 22px;
  line-height: 1;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

.gift-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
}

.gift-sub {
  font-size: 10px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
  letter-spacing: 0;
}

.gift-main {
  font-size: 14px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.3px;
}

/* 바디 */
.popup-body {
  padding: 22px 24px 18px;
}

.popup-field {
  margin-bottom: 14px;
}

.popup-field label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 6px;
}

.popup-field input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14.5px;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  background: #fafafa;
}

.popup-field input:focus {
  border-color: var(--main-color1);
  background: #fff;
}

.popup-field input:disabled {
  background: #f3f3f3;
  cursor: not-allowed;
}

.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-inputs input {
  flex: 1;
  text-align: center;
  font-weight: 600;
  letter-spacing: 1px;
  min-width: 0;
}

.phone-dash {
  font-size: 16px;
  color: #999;
  flex-shrink: 0;
}

/* 동의 */
.popup-agree {
  margin: 12px 0 18px;
}

.popup-agree label {
  font-size: 12.5px;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.popup-agree input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--main-color1);
}

/* 버튼 */
.popup-submit {
  width: 100%;
  padding: 15px;
  background: var(--main-color1);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
  letter-spacing: -0.3px;
}

.popup-submit:hover:not(:disabled) {
  background: var(--main-color2);
}

.popup-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.popup-phone {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 18px;
  font-weight: 800;
  color: var(--main-color1);
  text-decoration: none;
  letter-spacing: 0.5px;
}

.popup-phone .phone-label {
  font-size: 11px;
  font-weight: 600;
  color: #888;
  letter-spacing: 0;
}

/* 오늘 하루 보지 않기 */
.popup-today {
  display: block;
  width: 100%;
  padding: 12px;
  background: #f5f5f5;
  border: none;
  font-family: inherit;
  font-size: 12.5px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
}

.popup-today:hover {
  color: #333;
}
</style>
